import React from 'react';
import Helmet from 'react-helmet';
import Media from 'react-media';
import Link from 'gatsby-link';

import HeaderBanner from '../components/Main/services/HeaderBanner';
import {
  Intro,
  Avantages,
  Gamme,
  Partenaire,
  Tableau,
} from '../components/Main/brand';
import ContactUs from '../components/Footer/ContactUs';
import { LinkButton } from '../components/Buttons';

const BrandTemplate = ({
  data: {
    contentfulBrandPage,
    contentfulAboutPage,
    allGammesXlsxCaterpillar,
    allGammesXlsxMercury,
    allGammesXlsxYanmar,
    allGammesXlsxKohler,
  },
}) => {
  const brandName =
    contentfulBrandPage.brandName === 'Kohler'
      ? 'Köhler'
      : contentfulBrandPage.brandName;
  const headerImage = contentfulAboutPage.headerImage;

  const introTitle = contentfulBrandPage.introTitle;
  const introContent =
    contentfulBrandPage.introContent.childMarkdownRemark.html;
  const introImage = contentfulBrandPage.introImage;

  const avantagesTitle = contentfulBrandPage.avantagesTitle;
  const avantagesContent =
    contentfulBrandPage.avantagesContent.childMarkdownRemark.html;
  const avantagesImage = contentfulBrandPage.avantagesImage;

  const gammeTitle = contentfulBrandPage.gammeTitle;

  const partenaireTitle = contentfulBrandPage.partenaireTitle;
  const partenaireList = contentfulBrandPage.partenaireList;
  const partenaireListIcon = contentfulBrandPage.partenaireListIcon;

  const locale = contentfulBrandPage.node_locale;

  const extLink = contentfulBrandPage.extLink;

  // Excel data
  // * depends of the brandName
  let excelData;

  switch (contentfulBrandPage.brandName.toLowerCase()) {
    case 'caterpillar':
      excelData = allGammesXlsxCaterpillar.edges;
      break;
    case 'mercury/mercruiser':
      excelData = allGammesXlsxMercury.edges;
      break;
    case 'yanmar':
      excelData = allGammesXlsxYanmar.edges;
      break;
    case 'kohler':
      excelData = allGammesXlsxKohler.edges;
      break;
    default:
      break;
  }

  const hreflang = contentfulBrandPage.node_locale === 'fr' ? 'en' : 'fr';
  const alternatePath =
    contentfulBrandPage.brandName.toLowerCase() === 'mercury/mercruiser'
      ? 'mercury-mercruiser'
      : contentfulBrandPage.brandName.toLowerCase();

  return (
    <div>
      <Helmet>
        <html lang={contentfulBrandPage.node_locale} />
        <title>{`Offshore Services - ${brandName}`}</title>
        <meta
          name="description"
          content={contentfulBrandPage.metaDescription}
        />
        <link
          rel="alternate"
          hreflang={hreflang}
          href={`https://www.offshoreservices.fr/${hreflang}/${alternatePath}/`}
        />
      </Helmet>
      <Media query={{ minWidth: 768 }}>
        {matches =>
          matches ? (
            <div style={{ marginBottom: 195 }}>
              <HeaderBanner title={brandName} image={headerImage} />
            </div>
          ) : (
            <div style={{ marginBottom: 215 }}>
              <HeaderBanner title={brandName} image={headerImage} />
            </div>
          )
        }
      </Media>

      <Intro title={introTitle} contentHTML={introContent} image={introImage} />

      <Avantages
        title={avantagesTitle}
        contentHTML={avantagesContent}
        image={avantagesImage}
      />

      <Gamme title={gammeTitle} />

      {/* TABLEAU ICI */}
      <Tableau data={excelData} locale={locale} />

      <center style={{ marginBottom: 15 }}>
        <LinkButton
          text={
            locale === 'fr'
              ? 'Consultez le site officiel'
              : 'Visite the official website'
          }
          to={extLink}
          isExternal
        />
      </center>

      <Partenaire
        title={partenaireTitle}
        list={partenaireList}
        listIcon={partenaireListIcon}
      />

      <ContactUs locale={locale} />
    </div>
  );
};

export default BrandTemplate;

export const brandQuery = graphql`
  query BrandQuery($id: String!) {
    contentfulBrandPage(id: { eq: $id }) {
      brandName
      metaDescription
      node_locale
      introTitle
      introContent {
        childMarkdownRemark {
          html
        }
      }
      introImage {
        title
        sizes(quality: 100) {
          base64
          aspectRatio
          src
          srcSet
          srcWebp
          srcSetWebp
          sizes
        }
      }
      avantagesTitle
      avantagesContent {
        childMarkdownRemark {
          html
        }
      }
      avantagesImage {
        title
        sizes(quality: 100) {
          base64
          aspectRatio
          src
          srcSet
          srcWebp
          srcSetWebp
          sizes
        }
      }
      gammeTitle
      partenaireTitle
      partenaireList
      partenaireListIcon
      extLink
    }

    contentfulAboutPage {
      headerImage {
        title
        sizes(quality: 100) {
          base64
          aspectRatio
          src
          srcSet
          srcWebp
          srcSetWebp
          sizes
        }
      }
    }

    allGammesXlsxCaterpillar {
      edges {
        node {
          modele
          cylindree
          puissance_administrative
          puissance_cv
          vitesse_de_rotation
        }
      }
    }

    allGammesXlsxMercury {
      edges {
        node {
          modele
          cylindree
          puissance_administrative
          puissance_cv
          puissance_kw
        }
      }
    }

    allGammesXlsxYanmar {
      edges {
        node {
          modele
          cylindree
          nb_cyl
          puissance_administrative
          puissance_cv
          transmission
          poids
        }
      }
    }

    allGammesXlsxKohler {
      edges {
        node {
          modele
          frequence
          puissance_fournie
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/brand.js